import * as React from 'react'
import { IProject } from '../..'

const DemoVideo = require('./demo.mp4')

const proj: IProject = {
    id: 'rink-devtools',
    name: 'Rink for Chrome DevTools',
    type: 'app',
    tags: ['aws', 'ec2', 'mysql', 'ux', 'react', 'typescript', 'sass', 'c++', 'electronjs', 'nodejs'],
    containsVideos: true,
    description: (
        <>
        <p>
            UI debugger and a full-blown IDE for web devs that runs inside Chrome devtools. Opens up
            source directory automatically upon hitting <kbd>F12</kbd>, no "workspaces" configuration required.
            Drop in replacement for <code>npm start</code> / <code>yarn start</code>
        </p>
        <video src={DemoVideo} controls style={{ width: '100%' }} />
        </>
    ),
    links: new Map()
        .set('Editor in action w/ React app', 'https://goo.gl/d64cgv')
        .set('Editor in action w/ Vue app', 'https://goo.gl/qVnbmD')
}

export default proj



// WEBPACK FOOTER //
// ./src/components/Projects/_projects/rink-devtools/index.tsx